import { GiftCardsUtilService } from '@core/services/ib-gift-cards-utils.service';
import { RedirectionLandingService } from '@core/services/ib-gift-cards-redirection-service';
import { GiftCardsConfigurationService } from '@src/app/features/pages/configuration/services/ib-gift-cards-configuration/ib-gift-cards-configuration-service';
import { cloneDeep } from 'lodash-es';
import * as angular from 'angular';

const componentOptions = {
    bindings: {
        model: '='
    },
    controllerAs : 'giftCardsConfigurationContributionFormCtrl',
    templateUrl: ['GiftCardsAppConstants', (GiftCardsAppConstants: GiftCardsAppConstant): string => `${GiftCardsAppConstants.templatesRoute}ib-gift-cards-configuration-contribution-form-view.html`]
};
const componentInfo = {
    module: 'ib-gift-cards-configuration-form-module',
    selector: 'ibGiftCardsConfigurationContributionForm',
    inject:['localStorageService',
        'GiftCardsAppConstants',  'GiftCardsConfigurationService',
        'CommonsModalService',  'RedirectionLandingService', 'GiftCardsUtilService',
        'DatalayerUtilsService', 'DigitalDataService',
        'CommonsUtilService', '$filter', '$rootScope', '$timeout', '$window'],
    required: ['ib-gift-cards-service-module']
};
export class ibGiftCardsConfigurationContributionForm implements ng.IController {
    public model: Types.ConfigurationModel ;
    public form: any;
    public importError: boolean = false;
    public extendedObject: any = {};
    public giftCardflow: string = this.GiftCardsAppConstants.GIFT_CARD_FLOWS.CONTRIBUTION;
    public urlParams: Types.RouteParams;
    constructor (
        private localStorageService: angular.local.storage.ILocalStorageService,
        private GiftCardsAppConstants: GiftCardsAppConstant,
        private GiftCardsConfigurationService: GiftCardsConfigurationService,
        private CommonsModalService: any,
        private RedirectionLandingService: RedirectionLandingService,
        private GiftCardsUtilService: GiftCardsUtilService,
        private DatalayerUtilsService:DatalayerUtilsService,
        private DigitalDataService: any,
        private CommonsUtilService: CommonsUtilService,
        private $filter: ng.IFilterService, private $rootScope, private $timeout, private $window) {
            
    }

    $onInit () {
        this.saveDestiny('REGOTR');
        let contribution = true;
    }
    firstElementPriceChecked  = () => {
        this.$rootScope.$broadcast('changeFixedPriceSelected');
        
        this.setConditionsTypeSelected();
    };
    setConditionsTypeSelected = () => {
        this.$timeout(() => {
            const firstPriceName = this.model.participationCheckboxGroup == 'true' ? this.model.importInfo.groupFixedPrices[0].name : this.model.importInfo.fixedPrices[0].name;
            this.$rootScope.$broadcast('setConditions', firstPriceName);
        }, 200);
    };
    saveDestiny = (destiny:string) => {
        this.localStorageService.set('giftCardDestiny', destiny);
        const cardDestiny:string = this.GiftCardsUtilService.setQuadrigamInfo();
        const step = this.GiftCardsAppConstants?.QUADRIGAM_STEPS.SELECCION;
        let codigoSeguimientoOld:string = this.localStorageService.get('TrackingCode');
        let codigoSeguimientoSplit = codigoSeguimientoOld.split('/')[2] = cardDestiny;
        let codigoSeguimientoNew = codigoSeguimientoOld.split('/')[0] + '/' + codigoSeguimientoOld.split('/')[1] + '/' + codigoSeguimientoSplit;

        if(destiny === 'REGMIO') {
            this.localStorageService.remove('cardDestiny');
            this.localStorageService.remove('theme');
            this.CommonsUtilService.setTitlePage('GIFT_CARD_CONFIGURATION_REGMIO_TITLE');
        }else{
            this.localStorageService.set('cardDestiny', destiny);
            this.CommonsUtilService.setTitlePage('GIFT_CARD_CONFIGURATION_REGOTR_TITLE');
        }
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(cardDestiny, null, this.GiftCardsUtilService.isUserLogged());
        this.DigitalDataService.addDigitalDataInfo({TrackingCode: codigoSeguimientoNew, Quadrigam: cardDestiny, Step: step});
        this.DatalayerUtilsService.sendDatalayerEvent(this.GiftCardsAppConstants.DATALAYER_EVENT_TYPES.VIEW);
        this.DigitalDataService.emitViewEvent();
        this.$timeout(() => {
            this.$rootScope.$broadcast('sendUpdateToMonetate');
            this.$rootScope.$broadcast('updateDatalayer');            
            this.$rootScope.$broadcast('updateDigitalData');
        });

    };

    completeForm = () :void => {
        this.form.$submitted = true;
        this.importError =false;
        if (this.form.$valid) {
            if(this.model.importGift) {
                this.extendedObject = {
                    currency : this.model.importInfo.currency.code,
                    importeTarjetaRegalo: this.model.importGift.amount
                };

                if(this.model.importGift.discount) {
                    this.extendedObject.importePagoCliente = this.model.importGift.discount.amount;
                }
            }
            this.importError = this.model.importGift === null;
            if( this.form.customAmount?.$error && this.form.customAmount?.$error?.pattern &&
                this.form.customAmount?.$error?.pattern === true) {
                this.importError =false;
            }
            if(this.importError) {
                angular.element('html,body').animate({ scrollTop: 'divImportError' }, 'slow');
                return;
            }

            const template :string = 'ib-modal-one-card-conditions-contribution.html';

            const info = this.model;

            this.CommonsModalService.openBuildGenericModal(
                info,
                template,
                'ib-modals--large-gift-card',
                'ibModalConditionsController'
            ).result.then(():void =>{
                this.goToPayment();
            }, ():void =>{
            });
        }else{
            const errorScroll = this.model.importGift === null ?'divImportError'
                : angular.element('[name="' + this.form.$name + '"]').find('.ng-invalid:visible:first').offset()?.top - angular.element('.ib-header-common--full-container').innerHeight();
            this.importError = this.model.importGift === null;
            angular.element('html,body').animate({ scrollTop: errorScroll }, 'slow');
        }
    };

    cancel = () :void=>{
        this.CommonsModalService.showGenericModal(true, 'ib-modal-back-gift-cards.html',
            { idModal: this.GiftCardsAppConstants.GIFT_CARDS_BACK }, null).result.then( () => {
            this.RedirectionLandingService.redirection(this.GiftCardsAppConstants.market.toLowerCase(), this.GiftCardsAppConstants.lang.toUpperCase());
        }, angular.noop);

    };

    openConditions = () :void => {
        const conditionsInfoRoute = this.model.participationCheckboxGroup == 'true' ? 'groupAllConditionsEquals' : 'allConditionsEquals';
        const template :string = this.model.importInfo.conditionInfo[conditionsInfoRoute] ? 'ib-modal-one-card-conditions.html' : 'ib-modal-some-cards-conditions.html';
        this.CommonsModalService.openBuildGenericModal(
            this.model,
            template,
            'ib-modals--large',
            'ibModalConditionsController'
        );

    };

    goToPayment = ():void =>{
        this.CommonsModalService.showWaitingModal('ib-modal-loading-plane',
            'ib-modals ib-modals--transparent ib-modals--loading-page', true, null );
        this.localStorageService.set('giftCardsFlowId', this.model.importInfo.flowId);
        this.GiftCardsConfigurationService.putGiftCard(
            this.GiftCardsConfigurationService.transformData(this.model, this.giftCardflow),
            this.model.importInfo.flowId,
            this.extendedObject
        ).then(() => {},
            (error)=>{
                this.CommonsModalService.finishWaiting();
                this.CommonsModalService.showGenericError(error).result.then(angular.noop, angular.noop);
            });
    };
}
try {
    const mod = angular.module(componentInfo.module);
    ibGiftCardsConfigurationContributionForm.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsConfigurationContributionForm })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibGiftCardsConfigurationContributionForm.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsConfigurationContributionForm })
    );
}
